// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileFragment, ClientProfileMinimalGrantorRelationshipFragment, RelationshipFragment, ClientProfileBasicFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileFragmentDoc, ClientProfileMinimalGrantorRelationshipFragmentDoc, RelationshipFragmentDoc, ClientProfileBasicFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateClientProfileMutationVariables = Types.Exact<{
  input: Types.CreateClientProfileWithDetailsInput;
}>;


export type CreateClientProfileMutation = { __typename?: 'Mutation', createClientProfile: (
    { __typename?: 'ClientProfile' }
    & ClientProfileFragment
  ) };

export const Operations = {
  Mutation: {
    CreateClientProfile: 'CreateClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateClientProfileDocument = gql`
    mutation CreateClientProfile($input: CreateClientProfileWithDetailsInput!) {
  createClientProfile(input: $input) {
    ...ClientProfile
  }
}
    ${ClientProfileFragmentDoc}`;
export type CreateClientProfileMutationFn = Apollo.MutationFunction<CreateClientProfileMutation, CreateClientProfileMutationVariables>;

/**
 * __useCreateClientProfileMutation__
 *
 * To run a mutation, you first call `useCreateClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientProfileMutation, { data, loading, error }] = useCreateClientProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientProfileMutation, CreateClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientProfileMutation, CreateClientProfileMutationVariables>(CreateClientProfileDocument, options);
      }
export type CreateClientProfileMutationHookResult = ReturnType<typeof useCreateClientProfileMutation>;
export type CreateClientProfileMutationResult = Apollo.MutationResult<CreateClientProfileMutation>;
export type CreateClientProfileMutationOptions = Apollo.BaseMutationOptions<CreateClientProfileMutation, CreateClientProfileMutationVariables>;